import styled, { css } from 'styled-components';

export const RadioStyled = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  &.two-columns {
    flex-direction: row;
    flex-wrap: wrap;

    > div {
      width: 50%;
    }
  }

  &.icon-on-the-right {
    > div {
      label {
        justify-content: space-between;
        flex-direction: row-reverse;

        svg {
          margin-right: 0 !important;
        }
      }
    }
  }

  label {
    svg {
      fill: #fff;
      .outer {
        stroke: ${({ theme }) => theme.kallisto.color.common.black[200]};
      }
    }
    &:hover {
      .outer {
        stroke: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
      }
    }
  }
  .selected-radio {
    .outer {
      stroke: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
    }
    .inner {
      stroke: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
      fill: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
`;
